module.exports = __webpack_public_path__ + "static/Melvin Brown II-242117608fe6f9cd0b00afd20afdb626.png";